export const scrollToTop = () => {
    setTimeout(() => {
        // if (window.innerWidth < 768) {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
        // }
    }, 400);
};

export const siteTitle = (title) => {
    document.title = title + ' | Forever Plants';
};

export const toggleReadmore = (element, button, textOpen, textClose) => {
    const el = document.getElementById(element);
    const btn = document.getElementById(button);

    if (el != null && btn != null) {
        el.classList.toggle('is-active');
        btn.classList.toggle('is-active');

        btn.classList.contains('is-active') ? (btn.innerHTML = textClose) : (btn.innerHTML = textOpen);
    }
};

export const toggleMenu = (element) => {
    const el = document.getElementById(element);
    if (window.innerWidth <= 768) {
        if (el != null) {
            el.classList.toggle('is-active');
            document.body.classList.toggle('no-scroll');
            var root = document.documentElement;
            root.classList.toggle('no-scroll');
        } else {
        }
    }
};

export const sidebarControl = () => {
    const el = document.getElementById('sidebar-wrapper');
    if (window.innerWidth > 768 && window.pageYOffset > 520) {
        el.classList.add('is-sticky');
    } else {
        el.classList.remove('is-sticky');
    }
};



// WEBPACK FOOTER //
// ./src/helpers/Helpers.jsx